import { Typography } from '@breetometer/components';
import { StatusIcon } from 'BreetAssets';
import { RowSection } from 'BreetComponents';
import { capitalizeFirstLetter, getTransactionStatus } from 'BreetHelpers';

import type { IRowStatusNote } from '../DialogWithdrawalHistoryDetails.helpers';

const RowStatusNote = ({ status, note, noteStatus = 'success' }: IRowStatusNote) => (
	<RowSection.Single
		label='Status'
		component={
			<div className='transactiondetails_value'>
				<StatusIcon status={getTransactionStatus(status)} />
			</div>
		}
		adminNote={
			note ? (
				<div className={`transactiondetailadminnote ${noteStatus}`}>
					<Typography as='h6'>Admin Note</Typography>
					<Typography as='p'>{capitalizeFirstLetter(note)}</Typography>
				</div>
			) : undefined
		}
	/>
);

export default RowStatusNote;
